import useAxiosMutation from 'hooks/useAxiosMutation';
import { useAxiosQuery } from 'hooks/useAxiosQuery';
import { SyntheticEvent } from 'react';
import { useQueryClient } from 'react-query';
import { FAVOURITE_PROJECTS_CACHE_KEY } from 'services/queryKeys';
import { FavouriteProject } from 'types';

export const useFavouriteProjects = () => {
  const queryClient = useQueryClient();

  const { data: favouriteProjects } = useAxiosQuery<FavouriteProject[]>(FAVOURITE_PROJECTS_CACHE_KEY, '/projects/my-projects/favourites/');

  const { mutateAsync, isLoading } = useAxiosMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(FAVOURITE_PROJECTS_CACHE_KEY);
    },
  });

  const addFavourite = (e: SyntheticEvent, projectId: number) => {
    e.preventDefault();
    mutateAsync({
      method: 'POST',
      path: `/projects/my-projects/${projectId}/favourites/`,
    });
  };

  const removeFavourite = (e: SyntheticEvent, projectId: number) => {
    e.preventDefault();
    mutateAsync({
      method: 'DELETE',
      path: `/projects/my-projects/${projectId}/favourites/`,
    });
  };

  return { favouriteProjects, addFavourite, removeFavourite, isLoading };
};
